<template>
  <div
    :class="showMobileHeader ? 'mp_wrap' : ''"
    v-if="username"
    @click="$emit('update:showMyPage', !showMyPage)"
    @mouseover="showMobileHeader ? false : $emit('update:showMyPage', true)"
    @mouseleave="showMobileHeader ? false : $emit('update:showMyPage', false)"
  >
    <a role="button" :class="showMyPage ? 'on' : ''"
      ><span> {{ title }}</span></a
    >
    <transition name="slide">
      <div class="dept" v-show="showMyPage">
        <ul>
          <li v-for="(menu, index) in topMenu" :key="index">
            <router-link
              :to="{
                name: menu.url,
                params: { parentId: menu.parent_id }
              }"
              @click.native="$emit('closeHeader')"
            >
              {{ menu.name }}</router-link
            >
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TopHeaderMyPage',
  props: {
    showMobileHeader: {
      default: false
    },
    showMyPage: {
      default: false
    }
  },
  components: {},
  directives: {},
  computed: {
    ...mapGetters(['name', 'username', 'device', 'memberLevelInfo'])
  },
  data() {
    return {
      title: '마이페이지',
      topMenu: [
        {
          Id: 0,
          name: '주문/배송조회',
          status: true,
          url: 'orderList',
          parent_id: 0
        },
        {
          Id: 0,
          name: '찜한 상품',
          status: true,
          url: 'favor',
          parent_id: 0
        },
        {
          Id: 0,
          name: '적립금충전',
          status: true,
          url: 'point',
          parent_id: 0
        },
        {
          Id: 0,
          name: '1:1문의',
          status: true,
          url: 'qna',
          parent_id: 0
        },
        {
          Id: 0,
          name: '정보관리',
          status: true,
          url: 'member',
          parent_id: 0
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.gnb_sl .swiper-container {
  padding: 0 10px;
}

/* my page*/
div.mp {
  cursor: pointer;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 200px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Header/components/TopHeaderMyPage.vue